import React from "react";
import ReactDOM from "react-dom/client";
import "././Cs/Ftwear.css";

// import "././Cs/Style.css";

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import "bootstrap/dist/css/bootstrap.min.css";
import Router from "./Router/Router";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>
);
